<div class="top-bar">
  <mat-card class="top-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Restaurant Selection</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <label for="restaurant-select">Select Restaurant:</label>
      <select id="restaurant-select" (change)="onRestaurantChange($event)">
        <option value="" disabled selected>Select a restaurant</option>
        <option
          *ngFor="let restaurant of restaurants"
          [value]="restaurant.name"
        >
          {{ restaurant.name }}
        </option>
      </select>
    </mat-card-content>
  </mat-card>
</div>
